import React, { useEffect, useState } from "react";
import { Header } from "./Navbar.Style";
import { CDBNavbar, CDBNavBrand } from "cdbreact";
import logoImage from "../../asset/logo_qpress.png";
import Container from "react-bootstrap/Container";
import { useNavigate } from "react-router-dom";
import { FaGlobe, FaSignOutAlt } from "react-icons/fa";
import LogoutModal from "./logout-moal/LogoutModal";
import "./NavBar.css";
import ReactTooltip from "react-tooltip";
import { useTranslation } from "react-i18next";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

const NavBar = () => {
  const name = window.localStorage.getItem("name");
  const surname = window.localStorage.getItem("surname");
  const authority = window.localStorage.getItem("authority");
  const { t, i18n } = useTranslation();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();
  const homePath =
    localStorage.authority === "ADMIN" ? "/dashboard_admin" : "/patients";
  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleConfirmLogout = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("name");
    localStorage.removeItem("surname");
    localStorage.removeItem("authority");
    setShowLogoutModal(false);
    navigate("/");
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    changeLanguage("it"); // Set the default language to Italian
  }, []);

  const languages = [
    { code: "en", name: "English" },
    { code: "it", name: "Italiano" },
  ];

  return (
    <>
      {authority && (
        <>
          <CDBNavbar
            scrolling
            style={{ width: "100%", padding: "0px", margin: "0px" }}
          >
            <Container
              style={{
                width: "100%",
                padding: "11px",
                margin: "0px",
              }}
            >
              <div className="logo-title-layer" style={{ width: "100%" }}>
                <CDBNavBrand href={homePath}>
                  <img
                    alt=""
                    src={logoImage}
                    width="160"
                    height="55"
                    className="d-inline-block align-top"
                  />
                </CDBNavBrand>
              </div>

              <div className="navbar-content">
                <span className="navbar-item">
                  {name} {surname} - {t(authority)}
                </span>
                <FaSignOutAlt
                  className="logout-icon"
                  onClick={handleLogoutClick}
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                  data-tip={t("logout")}
                />

                <div className="language-div">
                  <ReactTooltip place="bottom" type="dark" effect="solid" />
                  <DropdownButton
                    alignRight
                    title={
                      <span>
                        <FaGlobe style={{ marginRight: "5px" }} />
                        {i18n.language.toUpperCase()}
                      </span>
                    }
                    id="dropdown-menu-align-right"
                    variant="secondary"
                  >
                    {languages
                      .filter((lang) => lang.code !== i18n.language)
                      .map((lang) => (
                        <Dropdown.Item
                          key={lang.code}
                          onClick={() => changeLanguage(lang.code)}
                        >
                          {lang.name}
                        </Dropdown.Item>
                      ))}
                  </DropdownButton>
                </div>
              </div>
            </Container>
          </CDBNavbar>
          <LogoutModal
            show={showLogoutModal}
            handleConfirm={handleConfirmLogout}
            handleClose={handleCancelLogout}
            title={t("logout")}
            message={t("confirm_logout")}
            tag={t("logout")}
          />
        </>
      )}
      {!authority && (
        <>
          {/* <Header style={{ background: "#333", color: "#fff" }}> */}
          <Header>
            <CDBNavbar
              expand="md"
              scrolling
              style={{ width: "100%", paddingX: "0px" }}
            >
              <Container style={{ width: "100%", paddingX: "0px" }}>
                <div className="logo-title-layer" style={{ width: "100%" }}>
                  <CDBNavBrand href={homePath}>
                    <img
                      alt=""
                      src={logoImage}
                      width="160"
                      height="55"
                      className="d-inline-block align-top"
                    />
                  </CDBNavBrand>
                </div>

                <div className="navbar-content">
                  <div className="language-div">
                    <ReactTooltip place="bottom" type="dark" effect="solid" />
                    <DropdownButton
                      alignRight
                      title={
                        <span>
                          <FaGlobe style={{ marginRight: "5px" }} />
                          {i18n.language.toUpperCase()}
                        </span>
                      }
                      id="dropdown-menu-align-right"
                      variant="secondary"
                    >
                      {languages
                        .filter((lang) => lang.code !== i18n.language)
                        .map((lang) => (
                          <Dropdown.Item
                            key={lang.code}
                            onClick={() => changeLanguage(lang.code)}
                          >
                            {lang.name}
                          </Dropdown.Item>
                        ))}
                    </DropdownButton>
                  </div>
                </div>
              </Container>
            </CDBNavbar>
          </Header>
        </>
      )}
    </>
  );
};

NavBar.propTypes = {};
export default NavBar;
